<i18n src="@/lang/common.json"></i18n>
<i18n>
{
    "de": {
        "selectFunctionViaNavigation": "Bitte wählen Sie über die Navigationsleiste die gewünschte Funktion aus."
    }
}
</i18n>

<template>
    <div class="w3-container">
        <HomepageTitle />

        <p id="menu" class="w3-center">
            {{ $t('selectFunctionViaNavigation') }}
        </p>
    </div>
</template>

<script>
import store from '@/store'
import HomepageTitle from '@/components/HomepageTitle';

export default {
    name: 'home',
    components: {
        HomepageTitle
    },

    data () {
        return {
        }
    },

    computed: {
        currentUser: () => store.state.currentUser
    },

    mounted () {
        if (this.currentUser === null) {
            this.$router.push('/login')
            return
        }

        var chemg = this.currentUser.hasPrivilege('chemg')
        var wrmg = this.currentUser.hasPrivilege('wrmg')

        if (chemg && !wrmg) {
            this.$router.push('/chemg')
        } else if (wrmg && !chemg) {
            this.$router.push('/wrmg')
        }
    },

    methods: {}
}
</script>

<style scoped>
#menu {
    margin-top: 40px;
}
</style>
